
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { useBuyerInvestmentPreferences } from "@/hooks/useBuyerInvestmentPreferences";
import PurchasingTypesField from "./PurchasingTypesField";
import CloseTimeField from "./CloseTimeField";
import PreferredMarketsField from "./PreferredMarketsField";
import EmailPreferencesField from "./EmailPreferencesField";
import PushNotificationsField from "./PushNotificationsField";

const BuyerInvestmentPreferencesForm = () => {
  const {
    form,
    isEditing,
    setIsEditing,
    selectedMarkets,
    selectedPurchasingTypes,
    isLoading,
    handleMarketToggle,
    handlePurchasingTypeToggle,
    onSubmit,
    handleCancel
  } = useBuyerInvestmentPreferences();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Investment Preferences</CardTitle>
        {!isEditing && (
          <Button variant="outline" onClick={() => setIsEditing(true)}>
            Edit
          </Button>
        )}
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <PurchasingTypesField
              control={form.control}
              selectedPurchasingTypes={selectedPurchasingTypes}
              onPurchasingTypeToggle={handlePurchasingTypeToggle}
              isEditing={isEditing}
            />

            <CloseTimeField
              control={form.control}
              isEditing={isEditing}
            />

            <PreferredMarketsField
              control={form.control}
              selectedMarkets={selectedMarkets}
              onMarketToggle={handleMarketToggle}
              isEditing={isEditing}
            />

            <EmailPreferencesField
              control={form.control}
              isEditing={isEditing}
            />

            <PushNotificationsField isEditing={isEditing} />

            {isEditing && (
              <div className="flex justify-end gap-2">
                <Button type="button" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button 
                  type="submit" 
                  disabled={isLoading}
                  className="bg-godyspo-gold hover:bg-godyspo-gold/90 text-black"
                >
                  {isLoading ? "Saving..." : "Save Changes"}
                </Button>
              </div>
            )}
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};

export default BuyerInvestmentPreferencesForm;
